import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*
import kotlinx.coroutines.launch

@Composable
fun PlayersScreen(token: String?, role: String?) {
    var players by remember { mutableStateOf<List<PlayerDto>>(emptyList()) }
    var rosteredAnywhereIds by remember { mutableStateOf<Set<String>>(emptySet()) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }
    var refreshKey by remember { mutableStateOf(0) }

    var editingId by remember { mutableStateOf<String?>(null) }
    var editName by remember { mutableStateOf("") }
    var editFullName by remember { mutableStateOf("") }
    var editGender by remember { mutableStateOf("male") }
    var editRegistered by remember { mutableStateOf(false) }
    var editCard by remember { mutableStateOf(false) }
    var editEmail by remember { mutableStateOf("") }
    var editPhone by remember { mutableStateOf("") }

    val scope = rememberCoroutineScope()

    LaunchedEffect(refreshKey) {
        loading = true
        try {
            players = Api.fetchAllPlayers(token)
            rosteredAnywhereIds = Api.fetchRosteredPlayerIdsAnywhere(token)
            error = null
        } catch (e: Throwable) {
            error = "Načtení hráčů selhalo: ${e.apiMessage()}"
        }
        loading = false
    }

    Div(attrs = { classes("card") }) {
        H2 { Text("Hráči") }
        if (loading) Text("Načítám…")
        error?.let { Div { Text("Chyba: $it") } }

        Table {
            Tr {
                Th { Text("Zobrazované jméno") }
                Th { Text("Celé jméno") }
                Th { Text("Pohlaví") }
                Th { Text("Registrovaný") }
                Th { Text("Kartička") }
                Th { Text("Email") }
                Th { Text("Telefon") }
                Th { }
            }
            players.forEach { player ->
                if (editingId == player.id) {
                    Tr {
                        Td {
                            Input(type = InputType.Text) {
                                value(editName)
                                onInput { editName = it.value }
                            }
                        }
                        Td {
                            Input(type = InputType.Text) {
                                value(editFullName)
                                onInput { editFullName = it.value }
                            }
                        }
                        Td {
                            Select(attrs = { onChange { editGender = it.value ?: "male" } }) {
                                Option("male") { Text("Muž") }
                                Option("female") { Text("Žena") }
                            }
                        }
                        Td {
                            CheckboxInput(checked = editRegistered) { onInput { editRegistered = it.value } }
                        }
                        Td {
                            CheckboxInput(checked = editCard) { onInput { editCard = it.value } }
                        }
                        Td {
                            Input(type = InputType.Text) {
                                value(editEmail)
                                onInput { editEmail = it.value }
                            }
                        }
                        Td {
                            Input(type = InputType.Text) {
                                value(editPhone)
                                onInput { editPhone = it.value }
                            }
                        }
                        Td {
                            Button(attrs = {
                                onClick {
                                    if (editName.isNotBlank()) {
                                        scope.launch {
                                            try {
                                                Api.updatePlayer(
                                                    token, player.id, editName,
                                                    editFullName.ifBlank { null },
                                                    editGender, editRegistered, editCard,
                                                    editEmail.ifBlank { null },
                                                    editPhone.ifBlank { null },
                                                )
                                                editingId = null
                                                refreshKey++
                                            } catch (e: Throwable) {
                                                error = "Uložení selhalo: ${e.apiMessage()}"
                                            }
                                        }
                                    }
                                }
                            }) { Text("Uložit") }
                            Button(attrs = { onClick { editingId = null } }) { Text("Zrušit") }
                        }
                    }
                } else {
                    Tr {
                        Td { Text(player.name) }
                        Td { Text(player.fullName ?: "—") }
                        Td { Text(genderLabel(player.gender)) }
                        Td { Text(if (player.registered) "Ano" else "Ne") }
                        Td { Text(if (player.card) "Ano" else "Ne") }
                        Td { Text(player.email ?: "—") }
                        Td { Text(player.phone ?: "—") }
                        Td {
                            if (role.canManage()) {
                                Button(attrs = {
                                    onClick {
                                        editingId = player.id
                                        editName = player.name
                                        editFullName = player.fullName ?: ""
                                        editGender = player.gender ?: "male"
                                        editRegistered = player.registered
                                        editCard = player.card
                                        editEmail = player.email ?: ""
                                        editPhone = player.phone ?: ""
                                    }
                                }) { Text("Upravit") }
                                if (player.id !in rosteredAnywhereIds) {
                                    Button(attrs = {
                                        onClick {
                                            scope.launch {
                                                try {
                                                    Api.deletePlayer(token, player.id)
                                                    refreshKey++
                                                } catch (e: Throwable) {
                                                    error = "Smazání selhalo: ${e.apiMessage()}"
                                                }
                                            }
                                        }
                                    }) { Text("Smazat") }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
